import Icon from "assets/icons";
import Size from "shared/enums/Size";
import useManageCellService from "./service";
import CheckBox from "shared/form/core/checkbox";
import { ManageOrgAdminCellProps } from "./types";

export default function ManageOrgAdminCell(props: ManageOrgAdminCellProps) {
  const service = useManageCellService(props);

  return (
    <div className="manageOrgAdmin_orgAdminActions">
      {props.row.original.loggedInUser ? (
        <Icon.Check />
      ) : (
        <CheckBox
          label={""}
          name={"manage"}
          size={Size.SMALL}
          checked={props.value}
          onChange={service.changeHandler}
          disabled={!service.isParticipatingInProgram}
        />
      )}
    </div>
  );
}
